module.exports = __webpack_public_path__ + "static/media/smiley_link.b7e225c9.png";